/** @jsx jsx */
import { CompanyAvatar, CompanyAvatarProps } from "@eworkit/iris";
import { FC } from "react";
import { jsx } from "theme-ui";

import { getJobRequestClientInfo } from "@/data/job-requests";
import { JobRequestListDto } from "@/data/job-requests/types/JobRequest";
import { JobRequestShort } from "@/data/job-requests/types/JobRequestShort";

import eworkLogoPng from "./assets/ework-logo.png";

interface JobRequestClientAvatarProps extends CompanyAvatarProps {
  jobRequest: Partial<JobRequestListDto> | Partial<JobRequestShort>;
  administrator?: boolean;
}

export const JobRequestClientAvatar: FC<JobRequestClientAvatarProps> = ({
  jobRequest,
  administrator,
  ...restProps
}) => {
  const { name, administratorLogoPublicUrl, logoPublicUrl, promoteClient } = getJobRequestClientInfo(jobRequest);
  return (
    <CompanyAvatar
      name={name}
      img={
        promoteClient
          ? logoPublicUrl ?? eworkLogoPng
          : administrator
          ? administratorLogoPublicUrl ?? eworkLogoPng
          : eworkLogoPng
      }
      {...restProps}
    />
  );
};
